import {Flex} from 'exsportia-components'
import React, {FC, useMemo} from 'react'

import {isFunction} from '../../../utils/logic'
import {Chevron} from '../chevron/chevron'
import {GradientLoader} from '../gradient-loader/gradient-loader'
import {defaultSettings} from './settings'

export type NavigationListProps<ComponentProps extends {value: string}> = {
  Component: FC<ComponentProps>
  isLoading?: boolean
  withoutChevron?: boolean
  elementsSettings: ComponentProps[]
}

type ElementSettings = {
  // eslint-disable-next-line
  [key: string]: any
}

// eslint-disable-next-line
export const NavigationList: FC<NavigationListProps<any>> = ({
  isLoading = false,
  Component,
  elementsSettings = [],
  withoutChevron = false,
}) => {
  const skeletonData = Array(4).fill({})
  const valueToDisplay = useMemo(
    () =>
      (isLoading ? skeletonData : elementsSettings).map((elementSettings, index) => {
        // eslint-disable-next-line
        const hasOnClick = !isLoading && isFunction(elementSettings.onClick) && !elementSettings.disabled
        const componentSettings: ElementSettings = {}
        for (const key in elementSettings) {
          if (key !== 'onClick') {
            // eslint-disable-next-line
            componentSettings[key] = elementSettings[key]
          }
        }
        // eslint-disable-next-line
        const onClick = hasOnClick ? () => elementSettings.onClick(elementSettings.value) : null
        return (
          <Flex
            p={'8px 16px'}
            width='100%'
            onClick={onClick}
            alignItems='center'
            justifyContent='space-between'
            key={`navigationElement${index}`}
            cursor={hasOnClick ? 'pointer' : 'unset'}
            backgroundHover='rgba(0, 16, 61, 0.06)'
          >
            {isLoading ? <GradientLoader {...defaultSettings.textLoader} /> : <Component {...componentSettings} />}
            {!withoutChevron && (
              <Chevron
                // eslint-disable-next-line
                direction={!elementSettings.disabled ? 'right' : 'block'}
                styleType='simple'
              />
            )}
          </Flex>
        )
      }),
    [isLoading, elementsSettings],
  )

  return (
    <Flex
      width={defaultSettings.width}
      height={defaultSettings.height}
      flexDirection={defaultSettings.flexDirection}
    >
      {valueToDisplay}
    </Flex>
  )
}
